// ---------------- 4.0 -----------------------
import R0101_webs_4_0_isapi from './R0101/webs_4.0_isapi.json';
import R0102_webs_4_0_isapi from './R0102/webs_4.0_isapi.json';
import R0401_webs_4_0_isapi from './R0401/webs_4_0_isapi.json';
import R0504_webs_4_0_isapi from './R0504/webs_4.0_isapi.json';
// ------------- 5.0 -------------------------
import R0101_webs_5_0_isapi from './R0101/webs_5.0_isapi.json';
import R0102_webs_4_5_isapi from './R0102/webs_4.5_isapi.json';
import R0102_webs_5_0_isapi from './R0102/webs_5.0_isapi.json';
import R0303_webs_5_0_isapi from './R0303/webs_5.0_isapi.json';
import R0401_webs_5_0_isapi from './R0401/webs_5.0_isapi.json';
import R0501_webs_5_0_isapi from './R0501/webs_5.0_isapi.json';
import R0501_webs_5_0_otap from './R0501/webs_5.0_otap.json';
import R0504_webs_5_0_isapi from './R0504/webs_5.0_isapi.json';
import R0504_webs_5_0_otap from './R0504/webs_5.0_otap.json';
import R0604_webs_5_0_otap from './R0604/webs_5.0_otap.json';
import R0601_webs_5_0_otap from './R0601/webs_5.0_otap.json';
// ---------------- 独特的资源预加载-----------------------
import unique_remoteConfigTemplate from './unique/remoteConfigTemplate';


function mergeStaticLists(...lists) {
//   return lists.reduce((acc, curr) => acc.concat(curr), []);
  return [...new Set([].concat(...lists))];
}

//4.0的包直接给资源路径
function getFilePrecacheAll() {
  try {
    return mergeStaticLists(
      R0101_webs_4_0_isapi,
      R0102_webs_4_0_isapi,
      R0401_webs_4_0_isapi,
      R0504_webs_4_0_isapi);
  } catch (error) {
    console.log('mergeList error:', error);
    return [];
  }
}
// 5.0的包使用iframe访问index.html，在index.html里prefetch相应的资源，避免多次手动更新
async function get_5_0_UrlAll() {
  try {
    let mergeList = mergeStaticLists(
      R0101_webs_5_0_isapi,
      R0102_webs_4_5_isapi,
      R0102_webs_5_0_isapi,
      R0303_webs_5_0_isapi,
      R0401_webs_5_0_isapi,
      R0501_webs_5_0_isapi,
      R0501_webs_5_0_otap,
      R0504_webs_5_0_otap,
      R0504_webs_5_0_isapi,
      R0601_webs_5_0_otap,
      R0604_webs_5_0_otap);
    // 使用 Promise.all 处理并行请求
    const allResults = await Promise.all(
      mergeList.map(async (item) => {
        try {
          const response = await fetch(item.targetUrl);
          const htmlContent = await response.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(htmlContent, 'text/html');
          const scripts = doc.getElementsByTagName('script');

          // 处理每个脚本的 src
          return Array.from(scripts)
            .filter(script => script.hasAttribute('src') && !script.getAttribute('src').startsWith('./'))
            .map(script => {
              const rawSrc = script.getAttribute('src');
              // 拼接真实的url
              return item.baseUrl + rawSrc;
            });
        } catch (error) {
          console.error(`处理 ${item.targetUrl} 失败:`, error);
          return [];
        }
      })
    );
    const prefetchUrlList = allResults.flat();
    
    return prefetchUrlList;
  } catch (error) {
    console.error('全局错误:', error);
    return [];
  }
}

function getUniqueUrlAll() {
  try {
    return mergeStaticLists(
      unique_remoteConfigTemplate
    );
  } catch (error) {
    console.log('mergeUniqueList error:', error);
    return [];
  }
}
export {getFilePrecacheAll, get_5_0_UrlAll, getUniqueUrlAll};
